import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-check-gray',
  templateUrl: './icon-check-gray.component.html',
  styleUrls: ['./icon-check-gray.component.scss']
})
export class IconCheckGrayComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
